import { useTheme } from "next-themes";
import { Moon, Sun } from "lucide-react";

export const ThemeToggle = ({ testId = "theme-toggle" }) => {
  const { resolvedTheme, setTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return (
    <button
      data-testid={testId}
      aria-label="Toggle theme"
      onClick={() => setTheme(dark ? "light" : "dark")}
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-foreground/10 hover:bg-foreground/5 transition-colors"
    >
      {dark ? <Sun className="h-4 w-4 text-[#f59e0b]" /> : <Moon className="h-4 w-4 text-[#4f46e5]" />}
    </button>
  );
};
